// extracted by mini-css-extract-plugin
export default {"container":"FavoriteModelsComponent_container__lB8Kg"};